var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpecialOffer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_10",
    "data-name": "Group 10",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_37457",
    "data-name": "Tracciato 37457",
    d: "M2.129,25.049H15.658a9.1,9.1,0,0,1,11.72-11.72V8.318H0v14.6a2.13,2.13,0,0,0,2.129,2.129Z",
    transform: "translate(0 2.329)",
    fill: "#ab77ee"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_37458",
    "data-name": "Tracciato 37458",
    d: "M18.052,4.411V1.065a1.065,1.065,0,1,0-2.129,0V4.411a1.065,1.065,0,1,0,2.129,0Z",
    transform: "translate(4.458)",
    fill: "#ab77ee"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_37459",
    "data-name": "Tracciato 37459",
    d: "M27.378,4.268a2.13,2.13,0,0,0-2.129-2.129H23.79V3.812a2.345,2.345,0,1,1-4.689,0V2.139H8.276V3.812a2.345,2.345,0,1,1-4.689,0V2.139H2.129A2.129,2.129,0,0,0,0,4.268V8.223H27.378Z",
    transform: "translate(0 0.599)",
    fill: "#ab77ee"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_37460",
    "data-name": "Tracciato 37460",
    d: "M5.932,4.411V1.065a1.065,1.065,0,0,0-2.129,0V4.411a1.065,1.065,0,0,0,2.129,0Z",
    transform: "translate(1.065)",
    fill: "#ab77ee"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_37461",
    "data-name": "Tracciato 37461",
    d: "M20.6,12.778a7.822,7.822,0,1,0,5.531,2.291A7.822,7.822,0,0,0,20.6,12.778ZM23.688,24.85,20.6,23.04l-3.088,1.81.767-3.5L15.6,18.977l3.562-.351L20.6,15.346l1.434,3.279,3.562.351-2.676,2.378Z",
    transform: "translate(3.578 3.578)",
    fill: "#9f67e6"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpecialOffer);
export default __webpack_public_path__ + "static/media/specialOffer.8fc6ddbed0340ab60a8d17c93325142d.svg";
export { ForwardRef as ReactComponent };